// extracted by mini-css-extract-plugin
export var downArrow = "_9n-0";
export var label = "_9n-1";
export var treatmentCard = "_9n-3";
export var upArrow = "_9n-2";